import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ApplicationContextBoundComponent } from 'src/app/shared/components/application-context-bound.component';
import { CdContactInfo } from 'src/app/cd-request/models/closing-disclosure-doc-request.model';
import { EnumerationService } from 'src/app/services/enumeration-service';
import { EnumerationItem } from 'src/app/models/simple-enum-item.model';

export interface SellerAgentFormData {
  noRealEstateAgent: boolean;
  companyName: string;
  companyLicenseId: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  contactName: string;
  contactLicense: string;
  contactEmail: string;
  contactPhone: string;
}

@Component({
  selector: 'seller-agent',
  templateUrl: './seller-agent.component.html',
  styleUrls: ['./seller-agent.component.scss'],
  standalone: false
})
export class SellerAgentComponent extends ApplicationContextBoundComponent implements OnInit, OnChanges {

  @ViewChild('sellerAgentForm') sellerAgentForm: NgForm;

  @Input() sellerRealEstateAgent: CdContactInfo | undefined;
  @Input() noSellerRealEstateAgentUsed: boolean | undefined;

  formData: SellerAgentFormData = {
    noRealEstateAgent: false,
    companyName: '',
    companyLicenseId: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    contactName: '',
    contactLicense: '',
    contactEmail: '',
    contactPhone: ''
  };

  isLoading: boolean = false;
  states: EnumerationItem[] = [];

  constructor(
    protected readonly injector: Injector,
    private readonly _enumService: EnumerationService
  ) {
    super(injector);
    this.states = this._enumService.states;
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['sellerRealEstateAgent'] || changes['noSellerRealEstateAgentUsed']) {
      this.populateFormFromApiData();
    }
  }

  validateForm(): boolean {
    if (this.formData.noRealEstateAgent) {
      return true;
    }
    if (this.sellerAgentForm) {
      this.sellerAgentForm.form.markAllAsTouched();
      return this.sellerAgentForm.form.valid;
    }
    return true;
  }

  getFormData(): SellerAgentFormData {
    return { ...this.formData };
  }

  private populateFormFromApiData(): void {
    this.formData = {
      noRealEstateAgent: this.noSellerRealEstateAgentUsed === true,
      companyName: this.sellerRealEstateAgent?.companyName || '',
      companyLicenseId: this.sellerRealEstateAgent?.companyLicenseId || '',
      address: this.sellerRealEstateAgent?.companyAddress || '',
      city: this.sellerRealEstateAgent?.city || '',
      state: this.sellerRealEstateAgent?.state || '',
      zip: this.sellerRealEstateAgent?.zip || '',
      contactName: this.sellerRealEstateAgent?.contactFullName || '',
      contactLicense: this.sellerRealEstateAgent?.contactLicenseId || '',
      contactEmail: this.sellerRealEstateAgent?.contactEmailAddress || '',
      contactPhone: this.sellerRealEstateAgent?.contactPhoneNumber || ''
    };
  }
}
